import React from 'react';
interface BreadCrumbNodeProps {
  onClick?: any;
  children: string;
  containerStylesClass?: string;
}
function BreadCrumbNode(props: BreadCrumbNodeProps) {
  const { onClick, children, containerStylesClass } = props;
  return (
    <div
      id="breadcrumbnode-wrapper"
      data-testid="breadcrumbnode-wrapper"
      onClick={onClick}
      className={`marginCrumbs bread-crumbs-font ${containerStylesClass}`}
      title={children}
    >
      {children}
    </div>
  );
}

export default BreadCrumbNode;
